import { useContext } from "react";
import IntlContext from "containers/LanguageProvider/IntlContext";

export default function useIntl() {
  return useContext(IntlContext);
}
